import { STTypo, STTypoModels } from '@protector/components';
import { COLOR_OPTIONS } from 'config/style';
import type { Dayjs } from 'dayjs';
import type { DailyInsectCounts } from 'querys/regional-overview/regional-overview.query.models';
import { memo, useMemo } from 'react';
import { DIGITAL_TRAP_DAILY_INSECT_COUNT_CHIP, DIGITAL_TRAP_DAILY_INSECT_COUNTS_STRIP } from '../../domain/tests-id.constants';
import { buildDailyCountWindow, mapDailyCountsKeys } from '../../utils';
import styles from './daily-insect-counts-strip.module.css';

interface DailyInsectCountsStripProps {
  dailyCounts: DailyInsectCounts[];
  anchorDate: Dayjs;
  numberOfDays?: number;
}

const DailyInsectCountsStripComponent = ({ dailyCounts, anchorDate, numberOfDays = 7 }: DailyInsectCountsStripProps) => {
  const days = useMemo(() => buildDailyCountWindow({ anchorDate, numberOfDays }), [anchorDate, numberOfDays]);
  const { mapped } = useMemo(
    () =>
      mapDailyCountsKeys(
        dailyCounts,
        days.map(day => day.dateKey)
      ),
    [dailyCounts, days]
  );

  return (
    <ul className={styles.strip} data-testid={DIGITAL_TRAP_DAILY_INSECT_COUNTS_STRIP}>
      {days.map(day => (
        <li key={day.dateKey} className={styles.chip} data-day-cell data-testid={DIGITAL_TRAP_DAILY_INSECT_COUNT_CHIP}>
          <STTypo
            type={STTypoModels.TypeOptions.C2}
            fontFamily='Noto Sans'
            color={COLOR_OPTIONS.NEUTRAL_60}
            align='center'
            data-day-label
            customClassName={styles.dateLabel}>
            {day.label}
          </STTypo>
          <STTypo
            type={STTypoModels.TypeOptions.P2}
            fontFamily='Noto Sans'
            color={COLOR_OPTIONS.NEUTRAL_100}
            align='center'
            customClassName={styles.dateCount}>
            {mapped[day.dateKey]}
          </STTypo>
        </li>
      ))}
    </ul>
  );
};

export const DailyInsectCountsStrip = memo(DailyInsectCountsStripComponent);
